import React from 'react';
import { useTranslation } from 'react-i18next';
import PricingFields from '../../shared/economics/PricingFields';
import { MatterPricingValue } from './economicsConstants';

/**
 * The matter's pricing form.
 *
 * The form itself is `shared/economics/PricingFields` - a pricing model, a
 * currency, a budget and the two fields the model implies are the same five
 * fields on a project (US #2235/#2236, tasks #2249 + #2250). This wrapper
 * keeps the matter's own input ids and the matter noun in the help text, so
 * every existing call site and every existing test selector still resolves.
 */
interface MatterPricingFieldsProps {
  value: MatterPricingValue;
  onChange: (next: MatterPricingValue) => void;
  /** Surface inline validation errors (typically after a submit attempt). */
  showErrors?: boolean;
}

const MatterPricingFields: React.FC<MatterPricingFieldsProps> = ({
  value,
  onChange,
  showErrors = false,
}) => {
  const { t } = useTranslation();
  return (
    <PricingFields
      value={value}
      onChange={onChange}
      showErrors={showErrors}
      entityNoun={t('matter')}
      idPrefix="matter"
    />
  );
};

export default MatterPricingFields;
